const determineFactorForMaterial = (key, row) => {
  if (!row[key]) return null;
  let cleanName = row[key].split(" ")[0];

  // Remove paranthesis and content of paranthesis from string (in case of no space)
  cleanName = cleanName.replace(/\(.*?\)/g, "");

  // Find object key in row that contains cleanName (e.g. cleanName is "W-1" and columnName would be "W-1 [200]")
  let columnName = Object.keys(row).find((key) => key.includes(cleanName));
  if (!columnName) return 0;

  return Number(row[columnName].replace(",", "."));
};

const removeVariantNumberPrefix = (string) => {
  // Remove [] brackets and their content from string
  return string.replace(/\[.*?\]/g, "").trim();
};

const getVariantNumberPrefixFromCell = (string) => {
  // Get the variantNumberPrefix from the string (e.g. "200" from "W-1 [200]")
  let variantNumberPrefix = string.match(/\[(.*?)\]/g)[0].replace(/\[|\]/g, "");

  return variantNumberPrefix;
};

const getVariantNumberPrefixFromHeaderRow = (key, row) => {
  if (!row[key]) return null;
  let cleanName = row[key].split(" ")[0];

  // Remove paranthesis and content of paranthesis from string (in case of no space)
  cleanName = cleanName.replace(/\(.*?\)/g, "");

  // Find object key in row that contains cleanName (e.g. cleanName is "W-1" and columnName would be "W-1 [200]")
  let columnName = Object.keys(row).find((key) => key.includes(cleanName));

  return getVariantNumberPrefixFromCell(columnName);
};

export { determineFactorForMaterial, getVariantNumberPrefixFromCell, getVariantNumberPrefixFromHeaderRow, removeVariantNumberPrefix };
